import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setHeaderTitle } from "../../../../redux/headerTitle/headerTitleSlice";
import { changeRouteType, getpervInnerState } from "../../../../redux/handleBackBtn/handleBackBtnSlice";
import FourPartsCard from "../../../../components/card/fourPartsCard/fourPartsCard";
import ElementTitle from "../../../../components/title/elementTitle/elementTitle";
import { useMutation, useQueryClient } from "react-query";
import { GetCustomerSale } from "../../../../services/sale.service";
import { IGetCustomerSaleResponse } from "../../../../models/sale.model";
import { SALE_ID } from "../../../../config/cacheKey";
import SimpleCard from "../../../../components/card/simpleCard/simpleCard";
import './purchas.css';
import LoansSkeleton from "../../loansTab/Loans/loansSkeleton";
export default function PurchaseRecordDetail({ isTrade }: { isTrade?: boolean }) {
    const dispatch = useDispatch();
    const [data, setData] = useState<IGetCustomerSaleResponse>();
    const queryClient = useQueryClient();
    const saleId: number = queryClient.getQueryData(SALE_ID)!;
    const randomKeyForDispatch = Math.random();
    const { mutateAsync, isLoading } = useMutation(GetCustomerSale, {
        onSuccess: (data) => {
            setData(data)
        }
    });
    useEffect(() => {
        dispatch(setHeaderTitle({ color: 'var(--header-color)', header: 'جزییات خرید', parentRoute: 'purchase' }));
        dispatch(changeRouteType({ routeType: 'child' }));
        if (isTrade) {

            dispatch(getpervInnerState({ prevInnerState: `tradeProfile ${randomKeyForDispatch}` }));
        }
        else {

            dispatch(getpervInnerState({ prevInnerState: `purchaseRecords ${randomKeyForDispatch}` }));
        }
        mutateAsync({ saleId: saleId! });
    }, []);
    const purchase = [{ id: 0, title: 'کد سبد خرید', value: data?.factorNumber },
    { id: 1, title: 'تاریخ  و زمان خرید', value: data?.salesDatePersian },
    { id: 3, title: 'شناسه پرداخت نقدی', value: data?.onlineTransactionNumber }].filter(item => item.value != null);

    if (isLoading) {
        return <LoansSkeleton />;
    }
    return (
        <div className="p-5" style={{ height: 'calc(100svh - 120px)', overflowY: 'scroll' }}>

            <SimpleCard>
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", paddingBottom: "10px" }}>
                    <div style={{ alignContent: "flex-start" }}>
                        <span style={{ fontSize: ".85rem", fontWeight: "bold", paddingRight: "5px" }}> <img style={{ width: "20px", height: "20px", display: "inline-block" }} src={`data:image/png;base64,${data?.storeLogoBase64}`} />&nbsp; {data?.storeTitle}</span>
                    </div>

                </div>
                <hr className="sale-item-hr" />

                {purchase.map((item) => {
                    const isLong = item?.value && item?.value?.toString().length > 17;
                    return (
                        <div style={{ display: "flex", flexDirection: isLong ? "column" : "row", justifyContent: "space-between", paddingBottom: "10px" }}>
                            <div >
                                <span style={{ fontWeight: "normal", paddingRight: "5px", fontSize: '.85rem', color: "var(--tirnary-text-color)" }}>{item.title}</span>
                            </div>
                            <div className="flex items-center justify-end">
                                <span style={{ color: "var(--primary-text-color)", fontSize: '.85rem', textAlign: "end" }}>{item.value}</span>
                            </div>
                        </div>
                    )
                })}

            </SimpleCard>
            {data?.saleTransactions && data?.saleTransactions.length > 0 &&
                <>
                    <div className="mt-5">
                        <ElementTitle title=" تراکنش ها (ریال)" />
                    </div>
                    <SimpleCard>


                        {data?.saleTransactions?.map((item) => (
                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", paddingBottom: "10px" }}>
                                <div style={{ alignContent: "flex-start" }}>
                                    <span style={{ fontWeight: "normal", paddingRight: "5px", fontSize: '.85rem', color: "var(--tirnary-text-color)" }}>{item.title} </span>
                                </div>
                                <div style={{ alignContent: "flex-end" }}>
                                    <span style={{ color: "var(--primary-text-color)", fontSize: '.85rem' }}> {item.amount?.toLocaleString()} </span>
                                </div>
                            </div>
                        ))}
                        <hr className="sale-item-hr" />
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", paddingBottom: "10px", fontSize: '.9rem !important' }}>
                            <div style={{ alignContent: "flex-start" }}>
                                <span style={{ fontSize: "0.9rem", fontWeight: "500", paddingRight: "5px", color: "var(--tirnary-text-color)" }}>جمع کل </span>
                            </div>
                            <div style={{ alignContent: "flex-start" }}>
                                <span style={{ fontWeight: "700", paddingRight: "5px", fontSize: "1.1rem" }}>{data.totalAmount?.toLocaleString()} </span>ریال
                            </div>

                        </div>
                    </SimpleCard>
                </>
            }

            {data?.saleItems && data?.saleItems.length > 0 &&
                <><div className="mt-5">
                    <ElementTitle title="اقلام خرید" />
                </div><SimpleCard>
                        {data?.saleItems?.map((item, index) => (
                            <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", paddingBottom: "10px", fontSize: '.85rem' }}>
                                <div style={{ alignContent: "flex-start" }}>
                                    <span style={{ fontSize: ".9rem", fontWeight: "normal", paddingRight: "5px" }}>{item.title} <span style={{ color: '#BBA57A', fontSize: '0.8rem' }}>({item.quantity})</span> </span>
                                </div>
                                <div style={{ textAlign: "left" }}>
                                    <span style={{ fontSize: "0.9rem", color: "var(--primary-text-color)" }}> {item.amount?.toLocaleString()} ریال  </span>
                                </div>{index !== data.saleItems.length - 1 && (<hr className="sale-item-hr" />)}

                            </div>
                        ))}
                    </SimpleCard></>}
        </div>
    )
}
